export default {
  stringSorter: function (ascending, a, b, columnName) {
    const regexMap = {
      a: new RegExp('[ÁÀÂÃ]', 'gi'),
      e: new RegExp('[ÉÈÊ&]', 'gi'),
      i: new RegExp('[ÍÌÎ]', 'gi'),
      o: new RegExp('[ÓÒÔÕ]', 'gi'),
      u: new RegExp('[ÚÙÛ]', 'gi'),
      c: new RegExp('[Ç]', 'gi')
    }

    var comparableStringA = a && a[columnName] ? a[columnName].toLowerCase() : ''
    var comparableStringB = b && b[columnName] ? b[columnName].toLowerCase() : ''
    for (var regex in regexMap) {
      comparableStringA = comparableStringA.replace(regexMap[regex], regex)
      comparableStringB = comparableStringB.replace(regexMap[regex], regex)
    }
    if (ascending) {
      return (comparableStringA >= comparableStringB) ? 1 : -1
    }
    return (comparableStringA <= comparableStringB) ? 1 : -1
  },

  booleanSorter: function (ascending, a, b, columnName) {
    var comparableStringA = a[columnName] ? 1 : 0
    var comparableStringB = b[columnName] ? 1 : 0
    if (ascending) {
      return (comparableStringA >= comparableStringB) ? 1 : -1
    }
    return (comparableStringA <= comparableStringB) ? 1 : -1
  },

  dateSorter: function (ascending, a, b, columnName) {
    var dateA = new Date(a[columnName])
    var dateB = new Date(b[columnName])
    if (ascending) {
      return (dateA - dateB)
    }
    return (dateB - dateA)
  },

  cleanLowerString: function (name) {
    const regexMap = {
      a: new RegExp('[ÁÀÂÃ@]', 'gi'),
      e: new RegExp('[ÉÈÊẼ&]', 'gi'),
      i: new RegExp('[ÍÌÎĨ]', 'gi'),
      o: new RegExp('[ÓÒÔÕ]', 'gi'),
      u: new RegExp('[ÚÙÛŨ]', 'gi'),
      c: new RegExp('[Ç]', 'gi')
    }

    var cleanString = name ? name.toLowerCase() : ''
    for (var regex in regexMap) {
      cleanString = cleanString.replace(regexMap[regex], regex)
    }
    return cleanString
  },

  cleanUpperString: function (name) {
    const regexMap = {
      A: new RegExp('[ÁÀÂÃ@]', 'gi'),
      E: new RegExp('[ÉÈÊẼ&]', 'gi'),
      I: new RegExp('[ÍÌÎĨ]', 'gi'),
      O: new RegExp('[ÓÒÔÕ]', 'gi'),
      U: new RegExp('[ÚÙÛŨ]', 'gi'),
      C: new RegExp('[Ç]', 'gi')
    }

    var cleanString = name ? name.toUpperCase() : ''
    for (var regex in regexMap) {
      cleanString = cleanString.replace(regexMap[regex], regex)
    }

    // Remove caracteres especiais isolados da matriz regexMap
    return cleanString.replace(new RegExp('[^0-9a-zA-Z]+'), '')
  },

  arrayDottedSorter: function (data, field, order) {
    let isNumber = function (v) {
      return (+v).toString() === v
    }

    let sort = {
      asc: function (a, b) {
        let i = 0
        let l = Math.min(a.value.length, b.value.length)

        while (i < l && a.value[i] === b.value[i]) {
          i++
        }
        if (i === l) {
          return a.value.length - b.value.length
        }
        if (isNumber(a.value[i]) && isNumber(b.value[i])) {
          return a.value[i] - b.value[i]
        }
        return a.value[i].localeCompare(b.value[i])
      },
      desc: function (a, b) {
        return sort.asc(b, a)
      }
    }
    let mapped = data.map(function (el, i) {
      return { index: i, value: el[field].split('.') }
    })

    mapped.sort(sort[order] || sort.asc)
    return mapped.map(function (el) {
      return data[el.index]
    })
  }
}



// WEBPACK FOOTER //
// ./client/utils/customSorter.js